/* eslint-disable import/prefer-default-export */
import { useRef, useEffect, useState } from 'react';

const usePrevious = (value) => {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
};

const defaultShouldUpdate = (a, b) => !Object.is(a, b);

function usePreviousStrict(state, shouldUpdate = defaultShouldUpdate) {
  const prevRef = useRef();
  const curRef = useRef();

  if (shouldUpdate(curRef.current, state)) {
    prevRef.current = curRef.current;
    curRef.current = state;
  }

  return prevRef.current;
}

// const usePreviousStrict = (value) => {
//   const [current, setCurrent] = useState(value);
//   const [previous, setPrevious] = useState(null);

//   if (value !== current) {
//     setPrevious(current);
//     setCurrent(value);
//   }

//   return previous;
// };
export { usePrevious, usePreviousStrict };
